import Button from '@mui/material/Button';

const ProvideFeedbackButton = () => {
  const openSurvey = () => { window.open('https://broadband.masstech.org/broadband-coverage-mapping-feedback-form'); };

  return (
    <Button
      sx={{
        background: '#1b3665',
        fontSize: 12,
        color: 'white',
        whiteSpace: 'nowrap',
        padding: '5px 10px',
      }}
      size="small"
      onClick={openSurvey}
    >
      Map Feedback
    </Button>
  );
};

export default ProvideFeedbackButton;
